import React, { useState } from "react";
import "./OrderHistoryStyle.css";
import { OrderStatusId } from "../../Utils/constant";
import { isEmpty } from "../../Utils/utils";
import GenericModal, { useGenericModal } from "../Modal/GenericModal";


export default function OrderHistory({
    orders = [],
    onActionClick, onInitiatePaymentAgain,
    actionLabel = "Action",
    title = "Order History",
}) {

    const [item, setItem] = useState(null);
    const [open, setOpen] = useState(false);

    const {
        genericModal,
        openModal,
        closeModal,
    } = useGenericModal();

    const handleStatusClick = (delivery) => {
        setItem(delivery);
        setOpen(true);
    };

    const closeDialog = () => {
        setOpen(false);
        setItem(null);
    };

    const getDeliveryClassName = (deliverStatus) => {
        if (OrderStatusId.ASSIGNED === deliverStatus) return "assigned";
        if (OrderStatusId.ON_THE_WAY === deliverStatus) return "ontheway";
        if (OrderStatusId.DELIVERED === deliverStatus) return "delivered";
        return "initiated";
    }

    const handleOpenModal = (billNO, amt) => {
        openModal({
            title: "Initiate Payment again",
            subtitle: `Do you want to initiate payment again for Bill No : ${billNO} with amount ₹${amt}?`,
            content: <p>Please confirm your action.</p>,
            positiveText: "Pay",
            negativeText: "Decline",
            onPositive: () => {
                console.log("Positive clicked");
                closeModal();
                onInitiatePaymentAgain?.(billNO);
            },
            onNegative: () => {
                console.log("Negative clicked");
                closeModal();
            },
            outSideClickClose: false,
        });
    };
    const renderDestopUi = () => {
        return (
            <div className="order-history-table-wrapper">
                <div className="oh-table-scroll">
                    <table className="order-history-table">
                        <thead>
                            <tr>
                                <th>
                                    <div className="th-with-action">
                                        <span>Bill No</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="th-with-action">
                                        <span>On</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="th-with-action">
                                        <span>Amount / Item's</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="th-with-action">
                                        <span>Pay Status</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="th-with-action">
                                        <span>Deliver Status</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="th-with-action">
                                        <span>Generate</span>
                                    </div>
                                </th>
                                <th>
                                    <div className="th-with-action">
                                        <span>.</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {orders.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="empty-state">No orders found</td>
                                </tr>
                            ) : (
                                orders.map((o) => (
                                    <tr key={o.billNo}>
                                        <td className="cell-strong">{o.billNo}</td>
                                        <td>{o.billCreateAt}</td>
                                        <td>₹{Number(o.finalAmt || 0).toFixed(2)} / {o.itemList?.length ?? 0}</td>
                                        <td><span className={`status-badge ${String(o.billStatusId).toLowerCase()}`}>{o.billStatusId}</span></td>
                                        <td>
                                            <span
                                                className={`status-badge ${getDeliveryClassName(o.deliverStatus)} clk`}
                                                onClick={() => handleStatusClick(o)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {o.deliverStatus} 🔗
                                            </span>
                                        </td>


                                        <td className="action-cell">
                                            <button className="row-action-btn" onClick={() => onActionClick?.(o.billNo)}>
                                                Print
                                            </button>
                                        </td>
                                        <td className="action-cell">
                                            {o.billStatusId === OrderStatusId.INITIATED &&
                                                <button className="row-action-btn-initiate" onClick={() => handleOpenModal?.(o.billNo, Number(o.finalAmt || 0).toFixed(2))}>
                                                    Initiate Pay
                                                </button>
                                            }
                                            {o.billStatusId === OrderStatusId.REJECTED &&
                                                <span
                                                    title={o.reason || "Rejected By Owner"}
                                                    style={{ color: "#b42318", fontWeight: 700 }}>
                                                    Rejected By Owner
                                                </span>
                                            }
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    const renderMobileUi = () => {
        return (
            <div className="order-history-cards">
                {orders.length === 0 && <div className="empty-state">No orders found</div>}
                {orders.map((o) => (
                    <div className="order-card" key={o.billNo}>
                        <div className="order-card-header">
                            <div className="order-card-title">
                                <span className="bill-label">Bill No</span>
                                <span className="bill-value">{o.billNo}</span>
                            </div>
                        </div>

                        <div className="order-card-row">
                            <span className="label">On</span>
                            <span>{o.billCreateAt}</span>
                        </div>

                        <div className="order-card-row">
                            <span className="label">Amount / Count</span>
                            <span>${Number(o.finalAmt || 0).toFixed(2)} / {o.itemList?.length ?? 0}</span>
                        </div>

                        <div className="order-card-row">
                            <span className="label">Pay Status</span>
                            <span className={`status-badge ${String(o.billStatusId).toLowerCase()}`}>{o.billStatusId}</span>
                        </div>

                        <div className="order-card-row">
                            <span className="label">Deliver Status</span>
                            <span
                                className={`status-badge ${getDeliveryClassName(o.deliverStatus)} clk`}
                                onClick={() => handleStatusClick(o)}
                                style={{ cursor: "pointer" }}
                            >
                                {o.deliverStatus} 🔗
                            </span>
                        </div>

                        {(o.billStatusId === OrderStatusId.INITIATED || o.billStatusId === OrderStatusId.REJECTED) &&
                            <div className="order-card-actions">
                                {o.billStatusId === OrderStatusId.INITIATED &&
                                <button className="row-action-btn-initiate" onClick={() => handleOpenModal?.(o.billNo, Number(o.finalAmt || 0).toFixed(2))}>
                                    Initiate Pay
                                </button>
                                }
                                {o.billStatusId === OrderStatusId.REJECTED &&
                                    <span
                                        title={o.reason || "Rejected By Owner"}
                                        style={{ color: "#b42318", fontWeight: 700 }}>
                                        Rejected By Owner
                                    </span>
                                }
                            </div>
                        }
                        <div className="order-card-actions">
                            <button className="row-action-btn wide" onClick={() => onActionClick?.(o.billNo)}>
                                Generate Pdf
                            </button>
                        </div>

                    </div>
                ))}
            </div>
        )
    }


    return (
        <div className="oh-shell">
            <GenericModal
                {...genericModal}
                onClose={closeModal}
            />

            <div className="oh-panel">

                {/* Desktop / Tablet Table */}
                {renderDestopUi()}
                {/* Mobile Cards */}
                {renderMobileUi()}
            </div>
            {open && item && (
                <div className="dialog-overlay" onClick={closeDialog}>
                    <div className="dialog-box" onClick={(e) => e.stopPropagation()}>
                        <h2>{`Status : ${item?.deliverStatus}`}</h2>

                        <div className="dialog-content">
                            <p>
                                <strong>Delivery Name:</strong> {isEmpty(item?.delvName) ? "<not assigned>" : item?.delvName}
                            </p>
                            <p>
                                <strong>Reference Number:</strong>{" "}
                                {item?.homeDelvId ?? ""}
                            </p>
                            {
                                !isEmpty(item?.deliveryInformation) &&
                                <a
                                    href={item?.deliveryInformation}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="dialog-link"
                                >
                                    🔗 Click here to see delivery information
                                </a>
                            }
                        </div>

                        <button className="dialog-close" onClick={closeDialog}>
                            Close
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
